export default [
    {
        path: '/prerequisite/part-brands',

        name: 'Part Brands',

        component: () => import('@/views/prerequisite/part-brands'),
    },
];